import React from "react";
import { withTranslation } from 'react-i18next';


import '../css/footer.css'

import logoNatura2000 from '../../images/logoNatura2000.jpg';
import logoLife from '../../images/logoLife.jpg';

const footer = (props) => (

    <footer className="page-footer mt-md-7">
         <div className="footer-disclaimer">
            <p ><strong>{props.t("footer-disc")}</strong>{props.t("footer-discNext")}</p>
        </div>
        <div className="container-fluid">
            <div className="row p-3">
                <div className="col-md-4 pt-3 footer-legal">
                    <strong style={{fontSize: "16px",lineHeight: "24px", fontWeight: "600",color: "#212529"}}>{props.t("footer-nomEmp")}</strong><br />
                    <a href="/#" style={{paddingRight:"1rem", fontSize: "16px",lineHeight: "24px",
                    fontWeight: "400", textDecoration: "underline"}}>{props.t("footer-contacto")}</a>
                    <a href="/politica-de-privacidad" style={{paddingRight:"1rem", fontSize: "16px",lineHeight: "24px",
                    fontWeight: "400", textDecoration: "underline"}}>{props.t("footer-avisoLegal")}</a>
                    <a href="/mapa-web" style={{paddingRight:"1rem", fontSize: "16px",lineHeight: "24px",
                    fontWeight: "400", textDecoration: "underline"}}>{props.t("web_map")}</a>
                </div>
                <div className="col-md-4">
                    <div className="mb-3 text-center pt-3">
                        <a href="/#" className="fb-ic icono" title="Facebook" target="_blank">
                            <i className="fab fa-facebook-f fa-lg mr-md-3 mr-2 fa-2x"> </i>
                        </a>
                        <a href="/#" className="tw-ic icono" title="Twitter" target="_blank">
                            <i className="fab fa-twitter fa-lg  mr-md-3 mr-2 fa-2x"> </i>
                        </a>
                        <a href="/#" className="ins-ic icono" title="Instagram" target="_blank">
                            <i className="fab fa-instagram fa-lg  mr-md-3 mr-2 fa-2x"> </i>
                        </a>
                    </div>
                </div>
                <div className="col-md-4 text-right pt-3">
                    <p style={{fontSize: "1rem"}}>
                        {props.t("footer-contribucion")}
                    </p>
                    <a href="/#" className="mx-1" title="Natura 2000" target="_blank">
                        <img src={logoNatura2000} alt="Logotipo Natura 2000" />
                    </a>
                    <a href="/#" className="mr-2" title="Europa LIFE" target="_blank">
                        <img src={logoLife} alt="Logotipo Europa LIFE" />
                    </a>
                </div>
            </div>
        </div>
    </footer>

);

// export default footer;
export default withTranslation()(footer);
